import { useCallback, useSyncExternalStore } from 'react';
import { Content } from '@amzn/awscat-pattern-library-service-model';

import { useContentEditorService } from '../../contexts/ContentEditorServiceContext';

/**
 * Subscribes to the {@link ContentEditorService} and returns the latest
 * content (including staged edits). Returns undefined while no document is
 * loaded. Re-subscribes when the service instance changes.
 */
export function useContent(): Content | undefined {
  const service = useContentEditorService();

  // When the service emits 'changed', then re-read the content.
  const subscribe = useCallback(
    (onStoreChange: () => void) => service.on('changed', onStoreChange),
    [service],
  );
  return useSyncExternalStore(subscribe, () => service.content);
}
